package com.jingfangpai.smartTcm.model

import com.jingfangpai.common.data.model.CascadedOption
import com.jingfangpai.common.orm.mapping.MedicalRecordSignSymptomCharacteristic
import com.jingfangpai.common.orm.mapping.enums.MedicalRecordSignSymptomState
import com.jingfangpai.common.orm.mapping.enums.SignSymptomName
import com.jingfangpai.common.orm.mapping.enums.SignSymptomRelationType
import com.jingfangpai.signSymptom.model.SignSymptomIdAndName
import kotlinx.serialization.Serializable

@Serializable
class DiagnosisQuestionAndAnswerItem {
    var medicalRecordId:String?=null
    var medicalRecordSignSymptomId:String? = null ;//医案记录ID
    var weight:Int?=null
    var signSymptomId:String?=null //症状ID
    var signSymptomName: SignSymptomName?=null  //当为空时，展示下拉列表供选择（仅展示已添加到方证中的），当非空时，展示症状是否存在的选择
    var signSymptomAlias:String?=null
    var signSymptomState: MedicalRecordSignSymptomState?=null //症状是否存在
    var characteristicOptions:Array<CascadedOption<String>> = arrayOf() //症状特征选项，当症状存在时，展示特征选项
    var signSymptomCharacteristics = arrayOf<MedicalRecordSignSymptomCharacteristic>()
    var isAutoAnswered:Boolean = false //是否自动回答
    var autoAnsweredType:SignSymptomRelationType? = null //自动回答类型
    var autoAnsweredBasedOn:Set<SignSymptomIdAndName>?=null //自动回答基于
    var reachTheEnd:Boolean = false
}